import PropTypes from 'prop-types'
import Lottie from 'react-lottie'
import * as animationData from './data.json'

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

const Connection = ({ width, height }) => {
  return (
    <Lottie
      options={defaultOptions}
      isClickToPauseDisabled
      width={width}
      height={height}
    />
  )
}

Connection.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

export default Connection
